import { Controller } from "@hotwired/stimulus"

// Chart.defaults.global.colors[0..2], which is what these series have always actually drawn with.
// A three-colour override existed but never rendered, because the attribute carrying it was
// misspelled ("colours") and never bound. chart_defaults.js still sets the globals this chart
// inherits (legend hidden, Söhne as the default font).
const SERIES = [
  { label: "Gifts Sent", key: "sent", rgb: "151,187,205" },
  { label: "Gifts Redeemed", key: "redeemed", rgb: "220,220,220" },
  { label: "Gifts Shipped", key: "shipped", rgb: "247,70,74" }
]

function runningTotals(values) {
  let total = 0;
  return values.map(value => (total += value));
}

export default class extends Controller {
  static get targets() { return ["canvas"]; }
  static get values() { return { graph: Object }; }

  connect() {
    const datasets = SERIES.map(series => this.dataset(series));

    // A day with no snapshots at all leaves the canvas blank rather than drawing an empty chart.
    if (datasets[0].data.length === 0) { return; }

    this.chart = new Chart(this.canvasTarget, {
      type: "line",
      data: { labels: this.graphValue.dates, datasets: datasets },
      options: { responsive: true, maintainAspectRatio: false }
    });
  }

  disconnect() {
    if (this.chart) { this.chart.destroy(); }
  }

  dataset({ label, key, rgb }) {
    return {
      label: label,
      data: runningTotals(this.graphValue[key]),
      backgroundColor: `rgba(${rgb},0.2)`,
      borderColor: `rgba(${rgb},1)`,
      pointBackgroundColor: `rgba(${rgb},1)`,
      pointHoverBackgroundColor: `rgba(${rgb},0.8)`,
      pointBorderColor: "#fff",
      pointHoverBorderColor: `rgba(${rgb},1)`
    };
  }
}
